import React from 'react';
import { NavigationItem } from '../../constants/navigation';

interface SidebarItemProps {
  item: NavigationItem;
  isActive: boolean;
  isCollapsed: boolean;
  onClick: () => void;
  theme?: 'dark' | 'light';
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  item,
  isActive,
  isCollapsed,
  onClick,
  theme = 'light'
}) => {
  const IconComponent = item.icon;

  return (
    <div
      onClick={onClick}
      className="sidebar-item"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: isCollapsed ? '8px 0' : '10px 12px',
        justifyContent: isCollapsed ? 'center' : 'flex-start',
        cursor: 'pointer',
        borderRadius: '0',
        margin: '2px 8px',
        transition: 'all 0.2s ease',
        backgroundColor: isActive
          ? (theme === 'dark' ? 'rgba(172, 73, 73, 0.15)' : 'rgba(172, 73, 73, 0.1)')
          : 'transparent',
        borderLeft: isActive
          ? '3px solid #ac4949'
          : '3px solid transparent',
        color: isActive
          ? '#ac4949'
          : (theme === 'dark' ? '#9ca3af' : '#6b7280'),
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = theme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      <IconComponent
        style={{
          fontSize: '20px',
          flexShrink: 0,
          color: isActive ? '#ac4949' : (item.color || (theme === 'dark' ? '#9ca3af' : '#6b7280')),
        }}
      />
      {!isCollapsed && (
        <span style={{
          fontSize: '13.5px',
          fontWeight: isActive ? 600 : 500,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {item.label}
        </span>
      )}
    </div>
  );
};

export default SidebarItem;
